import * as Yup from 'yup'

const emptyStringToNull = (value: number | null, originalValue: unknown) =>
  typeof originalValue === 'string' && originalValue.trim() === '' ? null : value

export const advertisementValidationSchema = Yup.object({
  title: Yup.object({
    it: Yup.string().required('Campo obbligatorio'),
    en: Yup.string()
  }),
  description: Yup.object({
    it: Yup.string().required('Campo obbligatorio'),
    en: Yup.string()
  }),
  price: Yup.number().transform(emptyStringToNull).min(0).required('Prezzo obbligatorio'),
  included_expenses: Yup.number()
    .transform(emptyStringToNull)
    .min(0)
    .nullable()
    .required('Campo obbligatorio'),
  deposit: Yup.number()
    .transform(emptyStringToNull)
    .min(0)
    .nullable()
    .required('Campo obbligatorio'),
  min_contract_months: Yup.number()
    .transform(emptyStringToNull)
    .min(1)
    .nullable()
    .required('Campo obbligatorio'),
  contract_type: Yup.number()
    .transform(emptyStringToNull)
    .nullable()
    .required('Campo obbligatorio'),
  available_from: Yup.string().required('Campo obbligatorio'),
  available_to: Yup.string()
    .nullable()
    .test(
      'available-to-after-or-equal',
      'La data "Disponibile fino a" deve essere uguale o successiva a "Disponibile da"',
      function (value) {
        if (!value) return true

        const { available_from } = this.parent as { available_from?: string | null }
        if (!available_from) return true

        return value >= available_from
      }
    ),
  available_places: Yup.number()
    .transform(emptyStringToNull)
    .min(0)
    .nullable()
    .required('Campo obbligatorio'),
  max_places: Yup.number()
    .transform(emptyStringToNull)
    .min(0)
    .nullable()
    .required('Campo obbligatorio'),
  active: Yup.boolean(),
  approved: Yup.boolean().nullable(),
  features: Yup.array().of(Yup.number()),
  services_included: Yup.array().of(Yup.number()),
  boost_valid_until: Yup.string().nullable()
})

export const advertisementInitialValues = {
  title: { it: '', en: '' },
  description: { it: '', en: '' },
  price: null as number | null,
  included_expenses: null as number | null,
  deposit: null as number | null,
  min_contract_months: null as number | null,
  contract_type: null as number | null,
  available_from: null as string | null,
  available_to: null as string | null,
  available_places: null as number | null,
  max_places: null as number | null,
  active: true,
  approved: true as boolean | null,
  features: [] as number[],
  services_included: [] as number[],
  boost_valid_until: null as string | null
}

export type AdvertisementFormValues = typeof advertisementInitialValues
